<template>
  <div id="start">
    <v-card class="intro-dark">
      <v-card-title
        class="intro-header justify-center"
        style="line-height: 1.2em"
        >
        <v-layout column>
          <v-row align="center"
            justify="center"
            no-gutters
            >
            <v-img contain :src="partnerLogo" class="partner-logo">
            </v-img>
          </v-row>
          <v-row class="pt-4" align="center"
            justify="center"
            no-gutters
            v-if="hasStartTitle"
            >
            <mrx-translation
              :token="titleToken"
              class="full-word text-center"
            ></mrx-translation>
          </v-row>
        </v-layout>
      </v-card-title>

      <v-card-text
        class=" white--text intro-body text-center"
        style="line-height: 1.2em"
        id="welcome-message"
      >
        <mrx-translation token="app.welcome_message.title"></mrx-translation>
      </v-card-text>

      <v-card-text :class="isPpvEnabled ? 'pb-1' : 'pb-4'">
        <v-btn
          block
          @click="setStartId()"
          id="start-button"
          x-large
          class="white--text"
        >
          <mrx-translation token="app.form.button.start"></mrx-translation
        ></v-btn>
      </v-card-text>

      <v-card-text v-if="isPpvEnabled" class="pt-2">
        <v-btn
          block
          @click="goToPastVisits()"
          id="past-visits-button"
          x-large
          class="white--text"
        >
          <mrx-translation token="ppv.page.title" />
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import languageLogic from "@/mixins/languageLogic";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Start",
  mixins: [languageLogic],
  data() {
    return {
      drawer: null,
      useDefaultLogo: false,
      titleToken: 'app.header.title',
    };
  },
  computed: {
    partnerLogo() {
      return this.settings('logo')
    },
    hasStartTitle() {
      const translation = this.$t(this.titleToken)
      if (translation) {
        return translation !== this.titleToken
      } else {
        return false
      }
    },
    isPpvEnabled() {
      return this.$featureFlags.enablePPV
    },
    ...mapGetters({
      settings: 'v4/settings/get',
    }),
  },
  methods: {
    async setStartId() {
      this.$track(this.$analyticsEvents.ASSESSMENT_STARTED, {
        component: 'Start',
        partner_logo: this.settings('logo'),
        has_custom_title: this.hasStartTitle
      })
      await this.$store.dispatch("v4/startId/new");
      this.next();
    },
    goToPastVisits() {
      this.$router.push({ name: 'PastPatientVisits' });
    },
    ...mapActions({
      previous: "v4/navigate/previous",
      next: "v4/navigate/next",
    }),
  },
  mounted() {
    this.$store.dispatch("v4/reset");
  },
};
</script>

<style scoped>
  .partner-logo {
    max-width: 50vw;
    max-height: 70px;
  }

  @media screen and (min-width: 750px) {
    .partner-logo {
      max-width: 400px;
      max-height: 100px;
    }
  }
  
  .full-word {
    word-break: normal;
  }

  .v-card {
    margin: 40px;
  }
</style>
